import type { KpiMetrics } from '@marketing-hub/shared';

export type KpiSnapshot = { snapshot_date: string; metrics: KpiMetrics };

export function isoDateUtc(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function defaultKpiRange(): { from: string; to: string } {
  return kpiRangeForDays(30);
}

export function kpiRangeForDays(days: number): { from: string; to: string } {
  const to = new Date();
  const from = new Date();
  from.setUTCDate(from.getUTCDate() - (Math.max(1, days) - 1));
  return { from: isoDateUtc(from), to: isoDateUtc(to) };
}

export function sumMetricsLastDays(snapshots: KpiSnapshot[], days: number): KpiMetrics {
  const cutoff = new Date();
  cutoff.setUTCDate(cutoff.getUTCDate() - days);
  const cutoffStr = isoDateUtc(cutoff);

  let leads_total = 0;
  let leads_new = 0;
  let mails_sent = 0;
  let mails_bounce = 0;
  let mails_reply = 0;
  let unsubscribes = 0;
  let campaigns_running = 0;

  for (const s of snapshots) {
    if (s.snapshot_date < cutoffStr) continue;
    const m = s.metrics;
    leads_new += m.leads_new;
    mails_sent += m.mails_sent;
    mails_bounce += m.mails_bounce;
    mails_reply += m.mails_reply;
    unsubscribes += m.unsubscribes;
    campaigns_running = Math.max(campaigns_running, m.campaigns_running);
  }

  const last = snapshots[snapshots.length - 1]?.metrics;
  if (last) leads_total = last.leads_total;

  return {
    leads_total,
    leads_new,
    mails_sent,
    mails_bounce,
    mails_reply,
    reply_rate: mails_sent > 0 ? mails_reply / mails_sent : 0,
    bounce_rate: mails_sent > 0 ? mails_bounce / mails_sent : 0,
    unsubscribes,
    campaigns_running,
  };
}

export function formatPercent(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}
